import { render } from "./confirmnoteofinterest.vue?vue&type=template&id=513c1af0"
import script from "./confirmnoteofinterest.vue?vue&type=script&lang=js"
export * from "./confirmnoteofinterest.vue?vue&type=script&lang=js"

import "./confirmnoteofinterest.vue?vue&type=style&index=0&id=513c1af0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__